import React, { useState, useEffect, useRef } from "react";
import { Form, Row } from "react-bootstrap";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { Container, Col, Card, Button } from "react-bootstrap";
import ApiService from "../../ApiService";
const searchByOptions = {
  patient_email: {
    slug: "patient_email",
    display: "Email"
  },
  patient_dob: {
    slug: "patient_dob",
    display: "DOB(yyyy-mm-dd) e.g: 1991-12-30"
  },
  patient_name: {
    display: "Name",
    slug: "patient_name"
  },
  patient_phone: {
    display: "Phone Number",
    slug: "patient_phone"
  },
  patient_kit: {
    display: "Kit Id",
    slug: "patient_kit_id"
  },
};

export default function PatientFilter() {
  const searchRef = useRef(null);
  const [selectedSearchBy, setSelectedSearchBy] = useState("patient_name");
  const [searchResults, setSearchResults] = useState();
  const [loading, setLoading] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const [searchString, setSearchString] = useState("");

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const handleOnSearch = async e => {
    //` Return if searchStr is empty
    if (!selectedSearchBy) {
      handleSnackOpen("Patient search failed. Select an option before typing", "error");
      return;
    } else {
      if (e?.length > 1) {
        try {
          setLoading(true);
          const response = await ApiService.searchPatient({
            type: selectedSearchBy,
            term: e?.toLowerCase()
          });
          setSearchResults(response?.data);
        } catch (error) {
          handleSnackOpen(`Patient search failed.`, "error");
        } finally {
          setLoading(false);
        }
      } else {
        setSearchResults([]);
      }
    }
  };

  const handleOnClear = e => {
    setSearchResults([]);
    setSearchString("");
    searchRef.current.clear();
  };

  const getSearchLabel = (selectedSearchBy) => {
    if(selectedSearchBy === "patient_email") {
        return "email";
    }

    if(selectedSearchBy === "patient_dob"){
        return "dob";
    }
    if(selectedSearchBy === "patient_phone"){
      return "phone";
    }
    if(selectedSearchBy === "patient_kit_id"){
        return "kitId";
    }
    return "firstName";
  }

  return (
    <Row className="PatientSearchSection">
      <Form.Group as={Row} className="seachbyInput" controlId="fromLocation">
        {/* <Form.Label column md={3} sm={3}>
          Search by
        </Form.Label> */}
        <Col md={9} sm={8}>
          <Form.Select
            defaultValue={selectedSearchBy}
            required
            id="formSelect"
            onChange={e => {
              setSearchResults(null);
              setSelectedSearchBy(e.target.value);
            }}
          >
            <option disabled selected value="">
              Search patient by
            </option>

            {Object.entries(searchByOptions)?.map(([key, val]) => (
              <option onSelect={e => {}} value={val.slug}>
                {val.display}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Form.Group>

      <div className="searchBox">
        <HiMagnifyingGlass />
        <AsyncTypeahead
          id="searchBox-email"
          delay={200}
          ref={searchRef}
          isLoading={loading}
          labelKey={selectedSearchBy === "patient_email" ? "email" : selectedSearchBy === "patient_dob" ? "dob" : "firstName"}
          onSearch={handleOnSearch}
          onClear={handleOnClear}
          onInputChange={handleOnSearch}
          onPaste={handleOnSearch}
          options={searchResults || []}
          renderMenuItemChildren={(option, props, index) => {
            let primaryText = "";
            let secondaryText = "";

            if (selectedSearchBy === "patient_email") {
              primaryText = option.email;
              secondaryText = `${option.firstName} ${option.lastName} - ${option.dob}`;
            } else if (selectedSearchBy === "patient_dob") {
              primaryText = option.dob; // Assuming you have a property named 'dob' in your option object
              secondaryText = `${option.firstName} ${option.lastName} - ${option.email}`;
            } else {
              primaryText = `${option.firstName} ${option.lastName}`;
              secondaryText = `${option.email} - ${option.dob}`;
            }

            return (
              <div style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>
                <strong>{primaryText}</strong>
                <div>{secondaryText}</div>
              </div>
            );
          }}
          searchText="Searching..."
          placeholder={
            selectedSearchBy === "patient_email"
              ? "Type an Email to search"
              : selectedSearchBy === "patient_dob"
              ? selectedSearchBy === "patient_dob" ? "Search by DOB" : (selectedSearchBy == "patient_kit_id" ? "Type Kit Id" : "Type Patient Name")
              : "Type Patient Name"
          }
          style={{ width: "100%" }}
          useCache={false}
          value={searchString}
          onChange={e => {
            console.log(e);
            window.location.href = `/PatientProfile?patientId=${e[0].id}&idType=sub`;
          }}
        />
      </div>
    </Row>
  );
}
